import { ExclamationCircle } from "@styled-icons/bootstrap";
import { Row } from "components/primitives";
import styled from "styled-components";
import { QuickAction } from "types/Widget";

export const BlankAction: QuickAction = () => {
  const test = () => {
    console.log("Test Success");
  };

  return (
    <WidgetAction onClick={test}>
      <ExclamationCircle height="100%" color="var(--primary)" />
      <p>Blank Action!</p>
    </WidgetAction>
  );
};

export const WidgetAction = styled(Row)`
  justify-content: center;
  align-items: center;
  border: none;
  background-color: white;
  gap: 10px;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
`;
